import { GATEWAY, http } from '@/utils/request';
const DEFAULT_TOKEN =
  process.env.NODE_ENV === 'production'
    ? window.btoa(`${window._aspConfig.clientId}:${window._aspConfig.clientSecret}`)
    : window.btoa('d343c01ec8fa4a90b0ecf8cc33a115a4:YH4g2S4Rhu');

// 获取公钥
export const getKeys = () => {
  return http.get<string>(`${GATEWAY.AUTH}/oauth2/keys/public`, {
    headers: {
      Authorization: `Basic ${DEFAULT_TOKEN}`, // 不需要Authorization头
    },
  });
};

// 获取图形验证码
interface CaptchaInfo {
  captchaId: string;
  imgBase64: string;
}
export const getCaptchaInfo = () => {
  return http.post<CaptchaInfo>(
    `${GATEWAY.AUTH}/captcha`,
    {},
    {
      headers: {
        Authorization: `Basic ${DEFAULT_TOKEN}`, // 不需要Authorization头
      },
    }
  );
};

// 校验图形验证码
interface CaptchaParams {
  captchaId: string;
  captchaValue: string;
}
export const captchaVerify = (params: CaptchaParams) => {
  return http.post<boolean>(`${GATEWAY.AUTH}/captcha/verify`, params, {
    headers: {
      Authorization: `Basic ${DEFAULT_TOKEN}`,
    },
  });
};

// 获取验证码
interface GetAuthorizeParams {
  mobile: string;
}
export const getAuthorize = (params: GetAuthorizeParams) => {
  return http.post<boolean>(`${GATEWAY.AUTH}/sms/send/code`, params, {
    headers: {
      Authorization: `Basic ${DEFAULT_TOKEN}`,
    },
  });
};

// 登录
interface LoginInfo {
  access_token: string;
  accountId: string;
  user_name?: string;
  orgCode?: string;
  [key: string]: any; // 允许其他属性
}
export const loginIn = (params: URLSearchParams) => {
  return http.post<LoginInfo>(`${GATEWAY.AUTH}/oauth2/token`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${DEFAULT_TOKEN}`,
    },
  });
};

// 登录
export const loginOut = () => {
  return http.post(`${GATEWAY.AUTH}/oauth2/logout`);
};

interface AuthParams {
  appCode: string;
}
// 获取用户权限信息
interface AppResInfos {
  resId: string;
  parentResKey: string | null | undefined;
  resKey: string;
  resName: string;
  children: AppResInfos[] | null | undefined;
}
interface AuthInfo {
  appId: string;
  appCode: string;
  appName: string;
  appResInfos: AppResInfos[];
}
export const getUserAuth = (params: AuthParams) => {
  return http.get<AuthInfo>(`${GATEWAY.AUTH}/sys/personal/app/detail`, {
    params,
  });
};

interface ChangePasswordParams {
  oldPwd: string;
  newPwd: string;
}
export const changePassword = (params: ChangePasswordParams) => {
  return http.post<void>(`${GATEWAY.AUTH}/sys/personal/pwd/change`, params);
};

// 修改系统名称
interface ChangeSystemNameParams {
  name: string;
}
export const changeSystemName = (params: ChangeSystemNameParams) => {
  return http.post<void>(`${GATEWAY.ASP}/sys_web/set/info`, params);
};

// 获取系统名称
interface SystemNameResponse {
  sysWebId: string;
  name: string;
  tenantId: string;
}
export const getSystemNameApi = () => {
  return http.get<SystemNameResponse>(`${GATEWAY.ASP}/sys_web/query/info`);
};
